<template>
  <section id="about" class="rk-stats">
    <div class="rk-container">      
      <div class="rk-section__head">
        <div class="rk-kicker">
          <span class="rk-kicker__rule"></span>
           <span class="rk-kicker__text"><i class="bi bi-bar-chart"></i> Numbers that matter</span>
        </div>
        <h2>What running on Rental Kenya looks like</h2>
      </div>

      <div class="rk-stats__grid">
        <div class="rk-stat-card" v-reveal="{ delay: 0 }" v-tilt>
          <div class="rk-stat-card__icon"><i class="bi bi-houses"></i></div>
          <div class="rk-stat-card__value"><span v-count="{ value: 5000, suffix: '+' }">0</span></div>
          <div class="rk-stat-card__label">Units tracked across active landlords</div>
        </div>

        <div class="rk-stat-card" v-reveal="{ delay: 100 }" v-tilt>
          <div class="rk-stat-card__icon"><i class="bi bi-people"></i></div>
          <div class="rk-stat-card__value"><span v-count="{ value: 500, suffix: '+' }">0</span></div>
          <div class="rk-stat-card__label">Landlords &amp; agents managing daily</div>
        </div>

        <div class="rk-stat-card" v-reveal="{ delay: 200 }" v-tilt>
          <div class="rk-stat-card__icon"><i class="bi bi-graph-up-arrow"></i></div>
          <div class="rk-stat-card__value"><span v-count="{ value: 96, suffix: '%' }">0</span></div>
          <div class="rk-stat-card__label">Average on-time collection rate</div>
        </div>

        <div class="rk-stat-card" v-reveal="{ delay: 300 }" v-tilt>
          <div class="rk-stat-card__icon"><i class="bi bi-chat-dots"></i></div>
          <div class="rk-stat-card__value"><span v-count="{ value: 40000, suffix: '+' }">0</span></div>
          <div class="rk-stat-card__label">Automated SMS reminders sent monthly</div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup></script>

<style scoped>
.rk-container { max-width: 1200px; margin: 0 auto; padding: 0 1.5rem; }
.rk-stats { padding: 6rem 0 6.5rem; background: var(--paper-dim); }

.rk-kicker {
  display: inline-flex; align-items: center; gap: 0.85rem;
  margin-bottom: 1rem;
}
.rk-kicker__rule { width: 32px; height: 3px; background: var(--brass); border-radius: 2px; flex-shrink: 0; }
.rk-kicker__text {
  display: inline-flex; align-items: center; gap: 0.5rem;
  font-family: var(--font-mono); font-size: 0.95rem; font-weight: 700;
  letter-spacing: 0.12em; text-transform: uppercase; color: var(--brass);
}
.rk-kicker__text i { font-size: 1rem; }


.rk-section__head h2 {
  font-family: var(--font-display);
  font-weight: 400;
  font-size: 2.6rem;
  letter-spacing: -0.01em;
  color: var(--ink);
  line-height: 1.15;
}

.rk-section__head p {
  font-family: var(--font-body);
  font-size: 1.05rem;
  color: var(--ink);
  line-height: 1.6;
  margin: 0.9rem 0 0;
}

.rk-section__head {
  max-width: 640px;
  margin-bottom: 80px;
}

.rk-stats__grid { display: grid; grid-template-columns: repeat(4, 1fr); gap: 1.75rem; }

.rk-stat-card {
  background: var(--neu-surface);
  border-radius: var(--radius-lg);
  box-shadow: var(--neu-raised);
  padding: 2.25rem 1.75rem;
  text-align: center;
}

.rk-stat-card__icon {
  width: 52px; height: 52px; margin: 0 auto 1.25rem;
  border-radius: 50%; background: var(--neu-surface); box-shadow: var(--neu-inset);
  display: flex; align-items: center; justify-content: center;
  color: var(--brass); font-size: 1.4rem;
}

.rk-stat-card__value {
  font-family: var(--font-mono); font-weight: 600; font-size: 2.1rem;
  color: var(--ink); margin-bottom: 0.5rem;
}

.rk-stat-card__label {
  font-family: var(--font-body); font-size: 0.88rem; color: var(--slate);
  line-height: 1.5;
}

@media (max-width: 900px) {
  .rk-stats__grid { grid-template-columns: repeat(2, 1fr); }
}
@media (max-width: 560px) {
  .rk-stats { padding: 4.5rem 0; }
  .rk-stats__head h2 { font-size: 1.9rem; }
  .rk-stats__grid { grid-template-columns: 1fr; gap: 1.25rem; }
}
</style>